module.exports = __webpack_public_path__ + "static/img/center_logo.5ac37453.png";